import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import ManualPlantingPlanFormContainer from 'planting-plan-form/ManualPlantingPlanFormContainer';

var baseString = 'vra-planting-plan';
var classString = classNames({
  [`${baseString}`]: true,
  'vra-create-script-screen': true
});
const PlantingPlan = ({
  scriptType
}) => (
  <section
    className={classString}
    data-test-id={`create-script__manual-${scriptType}`}>
    <ManualPlantingPlanFormContainer />
  </section>
);

PlantingPlan.propTypes = {
  scriptType: propTypes.string.isRequired
};

export default PlantingPlan;
